import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import * as moment from 'moment';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';

import {environment} from 'environment';
import {AuthRequest} from '../../shared/auth-request/auth-request';

import {Settings, UserProfile} from '../model/model';

const HTTP_OK_CODE: number = 200;

type TimeInfoData = {
  utcOffset: number;
  lang?: string;
};

type DeviceInfoData = {
  token: string;
  type: string;
  name: string;
  appVersion: string;
};

@Injectable()
export class UserRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
  ) { }

  public setTimeInfo(utcOffset: number, lang: string): Observable<boolean> {
    const data: TimeInfoData = {
      utcOffset: utcOffset,
      lang: lang,
    };

    return this.authRequest.handleRequest(this.http
      .put(environment.user.timeInfoRoute, data, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public setDeviceInfo(token: string, type: string, name: string, appVersion: string): Observable<boolean> {
    const data: DeviceInfoData = {
      token: token,
      type: type,
      name: name,
      appVersion: appVersion,
    };

    return this.authRequest.handleRequest(this.http
        .post(environment.user.deviceRoute, data, {observe: 'response', responseType: 'text', withCredentials: true})
        .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public getUserProfile(type: string): Observable<UserProfile> {
    return this.authRequest.handleRequest(this.http
      .get(environment.user.profileRoute + '?type=' + type, {withCredentials: true}),
    ).pipe(map((response) => {return <UserProfile> response; }));
  }

  public getTargetGroups(): Observable<Array<any>> {
    return this.authRequest.handleRequest(this.http
      .get(environment.user.targetGroupsRoute, {withCredentials: true}),
    ).pipe(map((response) => {return <Array<any>> response; }));
  }

  public markBadgesDisplayed(userBadgeIds: Array<string>): Observable<boolean> {
    const data = {userBadgeIds: userBadgeIds};
    return this.authRequest.handleRequest(this.http
      .post(environment.user.markBadgesDisplayedRoute, data, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public setSettings(settings: Settings): Observable<boolean> {
    return this.authRequest.handleRequest(this.http
      .put(environment.user.settingsRoute, settings, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public markContentsDisplayed(userContentIds: Array<string>): Observable<boolean> {
    const data = {userContentIds: userContentIds};
    return this.authRequest.handleRequest(this.http
      .post(environment.user.markContentsDisplayedRoute, data, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public getLeader(leaderId: string): Observable<string> {
    return this.authRequest.handleRequest(this.http
      .get(environment.user.leaderRoute + '?id=' + leaderId, {withCredentials: true}),
    ).pipe(map((response) => {return <string> response; }));
  }

  public setLeader(leaderId: string): Observable<boolean> {
    return this.authRequest.handleRequest(this.http
      .post(environment.user.leaderRoute, {leaderId: leaderId}, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  public markLaunchReviewDone(): Observable<boolean> {
    return this.authRequest.handleRequest(this.http
      .post(environment.user.markLaunchReviewDoneRoute, {}, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

}
